export const fileupload = {
  colorScheme: {
    light: {
      root: {
        background: '{surface.50}',
        borderColor: '{surface.500}',
        color: '{surface.700}',
        borderRadius: '12px',
      },
      header: {
        background: '{surface.100}',
        color: '{surface.800}',
        borderColor: '{surface.200}',
        borderRadius: '12px',
        padding: '1rem',
        gap: '0.5rem',
      },
      content: {
        background: '{surface.50}',
        color: '{surface.700}',
        borderColor: 'transparent',
        padding: '2rem',
        gap: '1rem',
        highlightBorderColor: '{primary.color}',
      },
      file: {
        padding: '1rem',
        gap: '1rem',
        borderColor: '{surface.200}',
      },
      progressbar: {
        height: '0.5rem',
      },
    },
    dark: {
      root: {
        background: '{surface.700}',
        borderColor: '{surface.700}',
        color: '{surface.0}',
        borderRadius: '12px',
      },
      header: {
        background: '#586274',
        color: '#ffffff',
        borderRadius: '12px',

        padding: '1rem',
        gap: '0.5rem',
      },
      content: {
        background: '#4e525e',
        color: '#ffffff',
        borderColor: 'transparent',
        padding: '2rem',
        gap: '1rem',
        highlightBorderColor: '{primary.color}',
      },
      file: {
        padding: '1rem',
        gap: '1rem',
        borderColor: '{surface.700}',
      },
      progressbar: {
        height: '0.5rem',
      },
    },
  },
};
